/**
 * Pure builder for the sidebar's admin-only entries — same "pure nav-item
 * builder, tested directly" convention as configMenuNav.ts, kept in its own
 * file so importing it from a test never pulls in MainLayout's heavy
 * component-level dependencies (AIChatWidget, CommandPalette, workspace
 * hooks, ...).
 *
 * Users/Roles do NOT belong here: Task 11 owns a real Administration
 * section for that. A bare `/users` entry here pointed at a route App.tsx
 * no longer registers (it silently bounced to /connections) — this is the
 * one place that list is built, so adminNavItems.test.ts catches a repeat
 * without mounting MainLayout.
 */
export interface AdminNavEntry<TIcon> {
  text: string;
  icon: TIcon;
  path: string;
}

export function buildAdminNavItems<TIcon>(
  access: { modules: boolean; license: boolean },
  labels: { modules: string; license: string },
  icons: { modules: TIcon; license: TIcon },
): AdminNavEntry<TIcon>[] {
  const items: AdminNavEntry<TIcon>[] = [];
  // Modules are per-connection configuration: the connection owner and a
  // member whose role grants designer access see them. License is the
  // installation, so it stays platform-superuser only.
  if (access.modules) {
    items.push({ text: labels.modules, icon: icons.modules, path: '/modules' });
  }
  if (access.license) {
    items.push({ text: labels.license, icon: icons.license, path: '/settings/license' });
  }
  return items;
}
